import { createWorktreeEnvironmentAtoms } from "@afar-research/client-runtime/state/worktrees";

import { connectionAtomRuntime } from "../connection/runtime";

export const worktreeEnvironment = createWorktreeEnvironmentAtoms(connectionAtomRuntime);
